




















































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import moment from 'moment';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'
  import uniq from 'lodash/uniq';
import { concat } from 'lodash';

@Component({
  computed: {
    ...mapState('ubic', [
      'actor'
    ]),

    ...mapGetters('ubic', [
      'isAdmin', 'isController'
    ]),

    ...mapState(STORE_KEY, [
      'employeeId',
      'loaded', 'loading',
      'data', 'ds', 'period'
    ]),
  },
  components: {
    TitleBar,
  }
})
export default class ScopePlaning extends Vue {

  // actor!: any;
  // filter!: any;
  employeeId!: any;
  get dateMoment () {
    return moment().date()
  }
  get allowPrev () {
    return this.$route.query.prev
  }

  opened: any[] = []

  get titleStack () {
    const tags = [
      'Планирование',
    ]
    // @ts-ignore
    if (this.pipeline) { tags.push(this.pipeline.name); }

    return tags
  }

  get selectedView() {
    return this.$route.params.view || 'linked'
  }

  setParams(filterName: string, filterValue: any) {
    this.$router.replace({
      params: {
        ...this.$route.params,
        [filterName]: filterValue
      },
      query: this.$route.query
    })
  }

  closePeriod() {
    this.$store.dispatch(`${STORE_KEY}/closePeriod`);
  }

  changeFilterValue({field, newValue}: any) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        [field]: field == 'deliveryDate' ? moment(newValue).format('YYYY-MM-DD') : newValue
      }
    })
  }

  public setFilter(term: string) {
    this.$store.dispatch(`${STORE_KEY}/setFilter`, term);
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange()
  }

  toggle(row: any) {
    (this.$refs.table as any).toggleDetails(row)
  }

  onDetailToggle(row: any, to: string) {
    if (to == 'open') {
      this.opened = uniq([
        ...this.opened,
        row.client_id
      ]);
    } else {
      this.opened = uniq(
        this.opened.filter(($row) => $row.client_id != row.client_id)
      );
    }
  }

  public planChange(clientId: any, productId: any, productContainerId: any, index: any, $event: any) {
    console.log('changePlan', {clientId, productId, index, value: $event})
    this.$store.dispatch(`${STORE_KEY}/changePlan`, {clientId, productId, productContainerId, index, value: $event});
  }

  public monthPlanChange(clientId: any, productId: any, productContainerId: any, $event: any) {
    console.log('changeMonthPlan', {clientId, productId, value: $event});
    this.$store.dispatch(`${STORE_KEY}/changeMonthPlan`, {clientId, productId, productContainerId, value: $event});
    // console.log(productId, $event.target.value)
  }

  save() {
    this.$store.dispatch(`${STORE_KEY}/savePlanChanges`);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/setFilterValue`, {
        ...this.$route.params, ...this.$route.query
      });
  }

}
